export const numberFormat = (number) => {
  return Number(number)
    .toFixed(0)
    .replace(/(\.\d{2})\d*/, '$1')
    .replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
}

export default numberFormat
